import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13c4ab08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "our-stat-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "mediabuying-section-title" }
const _hoisted_4 = { class: "mediabuying-section-subtitle" }
const _hoisted_5 = { class: "stat__list" }
const _hoisted_6 = { class: "stat__item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "stat__title" }, "OUR STATS", -1))
const _hoisted_8 = { class: "stat__content" }
const _hoisted_9 = { class: "number__list" }
const _hoisted_10 = { class: "number__item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "number__title" }, ">5", -1))
const _hoisted_12 = { class: "number__subTitle" }
const _hoisted_13 = { class: "number__item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "number__title" }, "100+", -1))
const _hoisted_15 = { class: "number__subTitle" }
const _hoisted_16 = { class: "number__item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "number__title" }, "3+", -1))
const _hoisted_18 = { class: "number__subTitle" }
const _hoisted_19 = { class: "stat__item" }
const _hoisted_20 = { class: "stat__title" }
const _hoisted_21 = { class: "stat__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('stats.title')), 1),
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('stats.subTitle')), 1)
      ]),
      _createElementVNode("ul", _hoisted_5, [
        _createElementVNode("li", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("ul", _hoisted_9, [
              _createElementVNode("li", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("h6", _hoisted_12, _toDisplayString(_ctx.$t('stats.exp')), 1)
              ]),
              _createElementVNode("li", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("h6", _hoisted_15, _toDisplayString(_ctx.$t('stats.empl')), 1)
              ]),
              _createElementVNode("li", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("h6", _hoisted_18, _toDisplayString(_ctx.$t('stats.offices')), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_19, [
          _createElementVNode("h4", _hoisted_20, _toDisplayString(_ctx.$t('stats.cont')), 1),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_Button, { text: "All job offers" })
          ])
        ])
      ])
    ])
  ]))
}